<p-fieldset>
    <p-header class="article-title">
      <span class="article-title">Relatório de Titulares e Dependentes</span>
      <div class="header-buttons">
      </div>
    </p-header>
    <div class="filter-section">
      <form #filterForm="ngForm" class="filters-container">
          <div class="filter-row">
              <div class="form-control">
                  <label for="titleNumber">Número do Título</label>
                  <input id="titleNumber" pInputText type="text" [(ngModel)]="filters.titleNumber" name="titleNumber">
              </div>
              <div class="form-control">
                  <label for="codRegistration">Matrícula</label>
                  <input id="codRegistration" 
                         pInputText 
                         type="text" 
                         [(ngModel)]="filters.codRegistration" 
                         name="codRegistration"
                         placeholder="000000.00"
                         maxlength="9"
                         (input)="onCodRegistrationInput($event)"
                         (keypress)="onlyNumbers($event)">
              </div>
              <div class="form-control name-input">
                  <label for="name">Nome</label>
                  <input id="name" pInputText type="text" [(ngModel)]="filters.name" name="name">
              </div>
              <div class="form-control">
                  <label for="status">Status</label>
                  <p-dropdown id="status" [options]="statusOptions" [(ngModel)]="filters.status" name="status"
                      optionLabel="label" optionValue="value" appendTo="body">
                  </p-dropdown>
              </div>
              <div class="form-control">
                  <label for="dependentsFilter">Dependentes</label>
                  <p-dropdown id="dependentsFilter" [options]="dependentsOptions" [(ngModel)]="filters.dependentsFilter" name="dependentsFilter"
                      optionLabel="label" optionValue="value" appendTo="body">
                  </p-dropdown>
              </div>
          </div>
      </form>

      <div class="filter-actions">

          <div class="form-button clear-botton-container">
                    <button class=" easymarine clear-button" (click)="clearFilters()" type="button">{{ 'CLEAR' | translate }}</button>
                </div>
                <div class="form-button search-botton-container">
                    <button class="primary easymarine" (click)="loadCustomers()" type="button">{{ 'FIND' | translate }}</button>
                </div>
      </div>
    </div>
    <div class="table">
        <div class="total-records">
        Total de registros encontrados: {{filteredCustomers.length}}
    </div>
        <p-table [value]="filteredCustomers" id="customersTable" #customersTable [resizableColumns]="true" [autoLayout]="true"
        sortMode="multiple" [rows]="5000" [paginator]="true" [pageLinks]="5" [rowsPerPageOptions]="[5000]">
            <ng-template pTemplate="header">
                <tr>
                    <th [pSortableColumn]="'titleNumber'" style="width: 5%">N. Título <p-sortIcon [field]="'titleNumber'"></p-sortIcon></th>
                    <th [pSortableColumn]="'active'" style="width: 5%">Status <p-sortIcon [field]="'active'"></p-sortIcon></th>
                    <th [pSortableColumn]="'name'" style="width: 20%">Titular <p-sortIcon [field]="'name'"></p-sortIcon></th>
                    <th [pSortableColumn]="'phone'" style="width: 15%">Telefone <p-sortIcon [field]="'phone'"></p-sortIcon></th>
                    <th style="width: 50%">Dependentes</th>
                    <th style="width: 7%"><button
                         class="fab-button primary"
                         label="Exportar valores"
                         pTooltip="Exportar Valores"
                        tooltipPosition="left"
                        (click)="exportTable()"
                        >
                    <i class="pi pi-file"></i>
                 </button></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-customer>
                <tr>

                    <td [ngClass]="{ 'text-danger': !customer.active }">{{ getTitleNumber(customer) }}</td>
                    <td [ngClass]="{ 'text-danger': !customer.active }">{{ getStatusLabel(customer.active) }}</td>
                    <td [ngClass]="{ 'text-danger': !customer.active }">{{ getFormattedHolderName(customer) }}</td>
                    <td [ngClass]="{ 'text-danger': !customer.active }">{{ getPhoneFormatted(customer.phone) }}</td>
                    <td>
                        <div class="dependents-text">
                            <ng-container *ngIf="customer.dependents && customer.dependents.length > 0; else noDependents">
                                <div *ngFor="let dependent of customer.dependents" class="dependent-item">
                                    <span [ngClass]="{ 'text-danger': !dependent.active }">{{ getFormattedDependentCodRegistration(dependent.codRegistration) }} - {{ getStatusLabel(dependent.active) }} - {{ dependent.name }} - {{ getPhoneFormatted(dependent.phone) }}</span>
                                </div>
                            </ng-container>
                            <ng-template #noDependents>
                                Nenhum dependente
                            </ng-template>
                        </div>
                    </td>
                    <td></td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="100%" style="text-align: center; padding: 3rem 1rem;">
                        <div class="empty-state" style="display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 200px;">
                            <i class="pi pi-search" style="font-size: 4rem; color: #6c757d; margin-bottom: 1rem;"></i>
                            <p style="color: #6c757d; font-size: 1.1rem; margin: 0; max-width: 400px; text-align: center;">
                                Adicione algum filtro, ou apenas clique em Pesquisar para exibir os dados
                            </p>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-fieldset>
